import { default as confirm_account } from ":src/modules/attendance/confirm-account/routes";
import { default as accepted } from ":src/modules/attendance/accepted/routes";
import { default as certificate } from ":src/modules/attendance/certificates/routes";
export default {
  BASE: "/attendance",
  confirm_account,
  accepted,
  certificate,
};
